import React, { useEffect } from "react";
import { gql, useQuery, ApolloError } from "@apollo/client";
// @ts-ignore - JavaScript module without type declarations
import TicketMasterApolloClient from "../../TicketMasterApolloClient/TicketMasterApolloClient.js";
import "./DummyConnection.scss";

// GraphQL query for the health endpoint
const HEALTH_QUERY = gql`
  query Health {
    health {
      message
      status
      timestamp
    }
  }
`;

// Type definitions
interface HealthData {
  message: string;
  status: string;
  timestamp: string;
}

interface HealthResponse {
  health: HealthData;
}

interface QueryResponse {
  data?: HealthResponse;
  loading: boolean;
  error?: ApolloError;
}

interface ApolloClientConfig {
  uri: string;
  token?: string;
  context?: string;
  getCurrentSession?: () => Promise<any>;
}

interface DummyConnectionProps {
  apolloClient: ApolloClientConfig | null;
  onResponse?: (response: QueryResponse) => void;
}

interface DummyConnectionInnerProps {
  onResponse: (response: QueryResponse) => void;
}

// Internal component that uses the Apollo Client
const DummyConnectionInner: React.FC<DummyConnectionInnerProps> = ({ onResponse }) => {
  const { data, loading, error } = useQuery<HealthResponse>(HEALTH_QUERY);

  useEffect(() => {
    if (data || error) {
      onResponse({ data, loading, error });
    }
  }, [data, error, loading, onResponse]);

  if (loading) {
    return <div className="dummy-connection-loading">Loading...</div>;
  }
  if (error) {
     return <div className="dummy-connection-error">Error: {error.message}</div>;
  }
  if (data) {
    return (
      <div className="dummy-connection-success">
        <h3>Health Check Response:</h3>
        <div className="response-data">
          <p><strong>Message:</strong> {data.health.message}</p>
          <p><strong>Status:</strong> {data.health.status}</p>
          <p><strong>Timestamp:</strong> {new Date(data.health.timestamp).toLocaleString()}</p>
        </div>
      </div>
    );
  }
  return null;
};

// Main DummyConnection component
const DummyConnection: React.FC<DummyConnectionProps> = ({ 
  apolloClient, 
  onResponse = () => {} 
}) => {
  if (!apolloClient) {
    return <div className="dummy-connection-error">Error: Apollo client configuration is required</div>;
  }

  return (
    <TicketMasterApolloClient apolloClient={apolloClient}>
      <div className="dummy-connection-container">
        <div className="dummy-connection-header">
          <h2>Seemplicity GraphQL Connection Test</h2>
          <p>Testing connection to: {apolloClient.uri}</p>
        </div>
        <DummyConnectionInner onResponse={onResponse} />
      </div>
    </TicketMasterApolloClient>
  );
};

export default DummyConnection; 